import { dateTimeHelpers } from '@approvalmax/utils';
import moment from 'moment';
import { memo, useMemo } from 'react';
import { noValue } from 'shared/constants';
import {
    AccountingDomainEntitiesBudgetZeroAmountHandlingType,
    BudgetsQBooksDimensionType,
} from 'shared/data/webApp/v2';

import { BudgetParams as BudgetParamsWrapper } from '../../../BudgetParams/BudgetParams';
import { getCheckPeriodText, getSubdivideByText } from './BudgetParams.helpers';
import { messages } from './BudgetParams.messages';
import { BudgetParamsProps } from './BudgetParams.types';

export const BudgetParams = memo<BudgetParamsProps>((props) => {
    const { company, budget } = props;

    const isBudgetDisabled = !budget.isEnabled;

    const params = useMemo(() => {
        const result: { id: string; label: string; value: string }[] = [
            {
                id: 'status',
                label: messages.status,
                value: budget.isEnabled ? messages.active : messages.deactivated,
            },
            ...(budget.subdividedBy && budget.subdividedBy.type !== BudgetsQBooksDimensionType.none
                ? [
                      {
                          id: 'subdividedBy',
                          label: messages.subdividedBy,
                          value: budget.subdividedBy.label ?? getSubdivideByText(budget.subdividedBy.type),
                      },
                  ]
                : []),
            {
                id: 'zeroAmounts',
                label: messages.includeZeroAmountLabel,
                value:
                    budget.zeroAmountHandlingType === AccountingDomainEntitiesBudgetZeroAmountHandlingType.Consider
                        ? messages.zeroAmountConsider
                        : messages.zeroAmountNotConsider,
            },
            {
                id: 'lastSync',
                label: messages.lastSync,
                value: dateTimeHelpers.formatDate(budget.lastSyncDate) || noValue,
            },
            {
                id: 'checkPeriod',
                label: messages.checkPeriod,
                value: getCheckPeriodText(budget.checkPeriod, Number(budget.checkPeriodFirstMonth)),
            },
            {
                id: 'budgetPeriod',
                label: messages.budgetPeriod,
                value: `${moment.utc(budget.periodFrom.asDateTime).format('MMM YYYY')} - ${moment.utc(budget.periodTill.asDateTime).format('MMM YYYY')}`,
            },
        ];

        return result;
    }, [budget]);

    return <BudgetParamsWrapper company={company} params={params} isBudgetDisabled={isBudgetDisabled} />;
});

BudgetParams.displayName = 'BudgetParams';
